import { GET_CURRENT_USER, SET_CURRENT_USER } from "redux/TypeConstant"

const UserReducer=(state=JSON.parse(localStorage.getItem('CurrentUser')),action)=>{
    switch(action.type)
    {
        case SET_CURRENT_USER:
        return state = action.data

        case GET_CURRENT_USER:
            return state 

            default :
            return state
    }

}

export default UserReducer